import { createContext } from 'react'

import type { DocumentsManagementContextData } from './types'

export const DocumentsManagementContext = createContext<DocumentsManagementContextData | null>(null)
